import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Button,
  Chip,
  Dialog,
  TextField,
  IconButton,
  Tooltip,
  Autocomplete,
} from "@mui/material";
import AddCircleIcon from "@mui/icons-material/AddCircle";

export default function SearchFilter(props) {
  const [open, setOpen] = React.useState(false);
  const [searchcolumn, setSearchcolumn] = useState(null);
  const [searchState, setSearchState] = useState([]);
  const [search, setSearch] = useState("");

  const searchColumns = [
    { label: "وضعیت", searchColumn: "isActive" },
    { label: "کاربر", searchColumn: "isPublic" },
    { label: "سفارش", searchColumn: "allOrder" },
  ];

  useEffect(() => {
    if (!props.search) {
      setSearch("");
    }
    if (!props.searchcolumn) {
      setSearchcolumn("");
    }
  }, [props]);

  useEffect(() => {
    if (searchcolumn) {
      if (searchcolumn == "isActive") {
        setSearchState([
          { label: "فعال", value: "true" },
          { label: "غیرفعال", value: "false" },
        ]);
      } else if (searchcolumn == "isPublic") {
        setSearchState([
          { label: "عمومی", value: "true" },
          { label: "سفارشی", value: "false" },
        ]);
      } else if (searchcolumn == "allOrder") {
        setSearchState([
          { label: "عمومی", value: "true" },
          { label: "سفارشی", value: "false" },
        ]);
      }
    }
  }, [searchcolumn]);

  return (
    <Box
      sx={{
        gap: 2,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        mb: 2,
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
        }}
      >
        <Typography variant="subtitle1">فیلترها : </Typography>
        <Tooltip title="افزودن">
          <IconButton onClick={() => setOpen(true)}>
            <AddCircleIcon
              sx={{
                color: "primary.main",
              }}
            />
          </IconButton>
        </Tooltip>
        <Box
          style={{ direction: "ltr", display: "flex", alignItems: "center" }}
        >
          {props.search && props.searchcolumn && (
            <Chip
              label={searchState.find((m) => m.value == props.search)?.label}
              onDelete={(data) => {
                props.setSearchcolumn("");
                props.setSearch("");
                setSearchcolumn("");
                setSearch("");
              }}
              color="primary"
              sx={{
                px: 2,
                m: 0.5,
                "& .MuiChip-label	": {
                  px: 0,
                },
              }}
            />
          )}
        </Box>
      </Box>
      <Dialog
        maxWidth="sm"
        fullWidth
        onClose={() => setOpen(false)}
        open={open}
      >
        <Box
          sx={{ m: 3, my: 5 }}
          display="grid"
          gridTemplateColumns="repeat(12, 1fr)"
          gap={3}
        >
          <Box gridColumn="span 6">
            <Autocomplete
              size="small"
              value={searchcolumn ? searchcolumn : ""}
              onChange={(event, newValue) => {
                if (newValue) {
                  setSearch("");

                  setSearchcolumn(newValue);
                } else {
                  setSearchcolumn("");
                  setSearch("");
                }
              }}
              isOptionEqualToValue={(option, value) =>
                option.value === value.value
              }
              getOptionLabel={(option) => {
                if (option) {
                  return searchColumns.find((m) => m.searchColumn == option)
                    .label;
                }
                return "";
              }}
              options={
                searchColumns ? searchColumns.map((m) => m.searchColumn) : []
              }
              renderInput={(params) => (
                <TextField variant="outlined" {...params} label="بر اساس" />
              )}
            />
          </Box>
          <Box gridColumn="span 6">
            {searchcolumn && (
              <Autocomplete
                size="small"
                value={search ? search : ""}
                onChange={(event, newValue) => {
                  if (newValue) {
                    setSearch(newValue);
                  } else {
                    setSearch("");
                  }
                }}
                isOptionEqualToValue={(option, value) =>
                  option.value === value.value
                }
                getOptionLabel={(option) => {
                  if (option) {
                    return searchState.find((m) => m.value == option).label;
                  }
                  return "";
                }}
                options={searchState ? searchState.map((m) => m.value) : []}
                renderInput={(params) => (
                  <TextField variant="outlined" {...params} label="بر اساس" />
                )}
              />
            )}
          </Box>
          <Box
            gridColumn="span 12"
            sx={{ display: "flex", justifyContent: "center", mx: "auto" }}
          >
            <Button
              variant="contained"
              onClick={() => {
                props.setSearch(search);
                props.setSearchState("");
                props.setSearchcolumn(searchcolumn);
                setOpen(false);
              }}
              sx={{ width: "70px", mr: 2 }}
            >
              جستجو
            </Button>
            <Button
              variant="outlined"
              onClick={() => {
                setOpen(false);
              }}
              sx={{ width: "70px" }}
            >
              انصراف
            </Button>
          </Box>
        </Box>
      </Dialog>
    </Box>
  );
}
